import styled from 'styled-components';

export const StyledForm = styled.div`
  display: flex;
  width: 35rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  form {
    margin: 1.5rem;
    label {
      flex: 1 1 0;
      > * {
        margin: 1.5rem;
      }
    }
    button {
      display: block;
      margin: auto;
    }
  }
`;
